import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "pages/NotFound";

// Load page components only when their routes are visited.
const WebsiteX = lazy(() => import("pages/Website-X"));
const Final = lazy(() => import("pages/Final"));
// import AboutUs from "pages/LandingPage/components/aboutUs/AboutUs";
// import ContactUs from "pages/LandingPage/components/contact/LastContact";
// import Overview from "pages/LandingPage/components/overview/Overview";
// import Choose from "pages/LandingPage/components/choose/Choose";
// import { LandingPages } from "pages/LandingPage/LandingPages";

export default function RoutesInternal() {
  return (
    <Suspense
      fallback={
        <div className="h-100 d-flex flex-column align-items-center justify-content-center" role="status" aria-live="polite">
          Loading RedMorphX...
        </div>
      }
    >
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<WebsiteX />} />
        <Route path="/results/:scan_id" element={<Final />} />
        {/* <Route path="/aboutUs" element={<AboutUs />} /> */}
        {/* <Route path="/contactUs" element={<ContactUs />} /> */}
        {/* <Route path="/overviewPage" element={<Overview />} />
      <Route path="/ChooseUs" element={<Choose />} /> */}
        {/* <Route path="/landingPages" element={<LandingPages />} /> */}
      </Routes>
    </Suspense>
  );
}
